import React from "react";

const CodeSandboxLogo = props => (
  <svg id="codesandbox-logo" viewBox="0 0 1024 1024" {...props}>
    <title>{"CodeSandbox"}</title>
    <g fill="currentColor">
      <path d="M719.001 851V639.848L902 533.802v211.465L719.001 851M302.082 643.438L122.167 539.135v208.606l179.915 104.832V643.438M511.982 275.795l182.957-106.162L512.06 63 328.436 169.987l183.546 105.808" />
    </g>
    <g fill="none" stroke="currentColor" strokeWidth={80} strokeMiterlimit={10}>
      <path d="M899 287.833L509 513v450M122.167 289L511.5 513" />
      <path d="M121 739.083l389.917 223.959L901 738.333V288L511 62 121 289z" />
    </g>
  </svg>
);

export default CodeSandboxLogo;
